<!--
   // TODO: Fix it on next version inshaAllah
   <select #langselect (change)="translate.use(langselect.value)">
   <option *ngFor="let lang of translate.getLangs()" [value]="lang">
      {{ lang }}
   </option>
</select> -->
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#2994FF" type="ball-beat" [fullScreen]="true">
   <span role="status" aria-live="polite" aria-atomic="true" class="cdk-visually-hidden">
      {{ downloadText || ('app.loading' | translate) }}
   </span>
</ngx-spinner>
<router-outlet></router-outlet>
